function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "e-apm\\u0101c\\u012Bba",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "04.-E---apm\\u0101c\\u012Bba---Kontroljaut\\u0101jums",
  transform: "translate(-318.000000, -1639.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "FAQ",
  transform: "translate(294.000000, 1208.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Question-CTA",
  transform: "translate(0.000000, 402.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(24.000000, 29.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Base",
  fill: "#181A1F",
  x: 0,
  y: 0,
  width: 32,
  height: 32,
  rx: 16
}), /*#__PURE__*/React.createElement("path", {
  d: "M17,19 L17,21 L15,21 L15,19 L17,19 Z M19,12 L19,18 L15,18 L15,16 L17,16 L17,14 L13,14 L13,12 L19,12 Z",
  id: "Shape",
  fill: "#FFFFFF"
}))))));

function SvgIcAskQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9E3A6BAD-2F97-429D-82A2-BD80770C05F7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAskQuestion);
export default __webpack_public_path__ + "static/media/ic-ask-question.925633ca.svg";
export { ForwardRef as ReactComponent };